export default "__VITE_ASSET__DUtripWI__"